export async function authFetch(url, options = {}) {
  let accessToken = localStorage.getItem("access_token");
  let refreshToken = localStorage.getItem("refresh_token");

  // Helper to actually make the request
  async function doFetch(token) {
    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });
  }

  let response = await doFetch(accessToken);

  // If token is expired, try to refresh
  if (response.status === 401) {
    try {
      const errorData = await response.clone().json();
      if (
        errorData?.code === "token_not_valid" &&
        errorData?.messages?.some(
          (msg) =>
            msg.token_class === "AccessToken" &&
            msg.message === "Token is expired"
        )
      ) {
        // Try to refresh
        const refreshRes = await fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/token/refresh/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refresh: refreshToken }),
          }
        );
        if (refreshRes.ok) {
          const refreshData = await refreshRes.json();
          localStorage.setItem("access_token", refreshData.access);
          // Retry original request with new access token
          return doFetch(refreshData.access);
        } else {
          // Refresh failed, clear tokens and redirect to login
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          window.location.href = "/login";
          return Promise.reject("Session expired. Please log in again.");
        }
      }
    } catch (e) {
      // If error parsing JSON or other, just redirect
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";
      return Promise.reject("Session expired. Please log in again.");
    }
  }

  return response;
}